import ProductCategory from '@/models/storePanel/ProductCategory';
const getDefaultState = () => ({
  productCategories: [],
  productCategory: new ProductCategory(),
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setItems(state, payload) {
      state.productCategories = payload.map((c) => {
        c.expanded = false;
        c.loading = false;
        return c;
      });
    },

    setItem(state, payload) {
      state.productCategory = new ProductCategory(payload);
    },

    addItem(state, payload) {
      state.productCategories.unshift(payload);
    },

    updateItem(state, payload) {
      let index = state.productCategories.findIndex(
        (p) => p.product_category_id === payload.product_category_id
      );
      state.productCategories.splice(index, 1, payload);
    },

    removeItem(state, id) {
      state.productCategories = state.productCategories.filter((p) => p.product_category_id !== id);
    },
  },

  actions: {
    async getItems({ commit }, query) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await ProductCategory.get(query);

        const { product_categories, pagination } = data.data;

        commit('setItems', product_categories);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async create({ commit, state, rootState }) {
      try {
        commit('setLoading', true, { root: true });

        let productCategory = { ...state.productCategory };
        delete productCategory.product_category_id;
        if (!productCategory.name.en) productCategory.name.en = productCategory.name.el;
        if (!productCategory.name.it) productCategory.name.it = productCategory.name.el;

        const { data } = await ProductCategory.create(productCategory);

        commit('addItem', data.data.product_category);
        commit('setServerItemsLength', rootState.serverItemsLength + 1, { root: true });
        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully created product category!',
          },
          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async update({ commit, state }) {
      try {
        commit('setLoading', true, { root: true });

        let productCategory = { ...state.productCategory };

        if (!productCategory.name.en) productCategory.name.en = productCategory.name.el;
        if (!productCategory.name.it) productCategory.name.it = productCategory.name.el;

        const { data } = await ProductCategory.update(productCategory);

        commit('updateItem', data.data.product_category);
        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully updated product category!',
          },
          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async remove({ commit, state, rootState }) {
      try {
        commit('setLoading', true, { root: true });

        await ProductCategory.delete(state.productCategory.product_category_id);

        commit('setServerItemsLength', rootState.serverItemsLength - 1, { root: true });
        commit('setLoading', false, { root: true });
        commit('setDeleteDialog', false, { root: true });
        commit('removeItem', state.productCategory.product_category_id);
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: 'You have successfully deleted product category!',
          },
          { root: true }
        );
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
  },
};
